import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jx5r7yrney: FaireBrandEntity = {
  token: "b_jx5r7yrney",
  type: "brand",
  name: "Loam Candles",
  avatarUrl:
    "https://cdn.faire.com/fastly/2a89beecedd6c815b59e58a0ab6a31560a9eefb6caca9833f692eb1697870c83.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8473ec50a32571015f17d3f45b0b787b80755a1453b6cc22d1400c25459cc461.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2a89beecedd6c815b59e58a0ab6a31560a9eefb6caca9833f692eb1697870c83.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8473ec50a32571015f17d3f45b0b787b80755a1453b6cc22d1400c25459cc461.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 198,
  rating: 5,
  reviewCount: 27,
  isInsider: true,
  description:
    "Loam Candles is a small batch, handmade candle company based in Los Angeles, California. We craft scents that celebrate and honor the magic of a life lived in the garden and experienced outdoors. All Loam Candles are made with a blend of soy and coconut wax, cotton wicks and clean fragrances. ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:23.801Z",
    importedBy: "entity-db-cli",
  },
};
